module.exports = __webpack_public_path__ + "static/img/图片2.cbe4bba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/图片2.png
// module id = suC0
// module chunks = 1